import { FBPage } from 'components/FbUI/Page/FBPage'
import { CompanySidebarOld } from './Sidebar/CompanySidebarOld'
import type { CompanySidebarHeader, SidebarTabConfig } from './Sidebar'
import * as S from '../Cards/Cards.styles'
import { RouterLink } from 'components/UI/Anchor'
import { CompanyPageProvider } from './CompanyPageContext'

interface CompanyPageLayoutOldProps {
  breadcrumbRoot: string
  breadcrumbs?: { breadcrumb: string; title?: string; url?: string }[]
  chainProxyId: number
  sidebar: {
    header: CompanySidebarHeader
    tabs: SidebarTabConfig[]
  }
  doorId?: number
  address?: string
  phone?: string
  children?: React.ReactNode
}

/**
 * Original company page layout for old navigation.
 * @deprecated Delete when old nav is removed. See TODO in NewCompanyPage/index.tsx
 */
export function CompanyPageLayoutOld(props: CompanyPageLayoutOldProps) {
  const { chainProxyId } = props

  return (
    <FBPage className="gap-y-4" noContainer>
      {/* Breadcrumbs */}
      <div className="flex items-center self-stretch px-20 pb-6 pt-2">
        <S.BreadcrumbGroup>
          <S.BreadcrumbBadge pill>{props.breadcrumbRoot}</S.BreadcrumbBadge>
          {props.breadcrumbs?.map((breadcrumb, i) => (
            <S.BreadcrumbContainer key={i}>
              <S.RChevronIcon />
              <div>
                {breadcrumb.title && (
                  <S.BreadcrumbTitle>{breadcrumb.title}: </S.BreadcrumbTitle>
                )}
                {breadcrumb?.url ? (
                  <RouterLink to={breadcrumb.url} target="_blank">
                    {breadcrumb.breadcrumb}
                  </RouterLink>
                ) : (
                  <span>{breadcrumb.breadcrumb}</span>
                )}
              </div>
            </S.BreadcrumbContainer>
          ))}
        </S.BreadcrumbGroup>
      </div>

      {/* Content area */}
      <div className="flex justify-end gap-6 px-20 pb-0">
        <CompanySidebarOld
          chainProxyId={chainProxyId}
          {...props.sidebar}
          doorId={props.doorId}
          address={props.address}
          phone={props.phone}
        />

        <div className="flex-1 min-w-0 flex flex-col gap-6">
          <CompanyPageProvider mode="old">{props.children}</CompanyPageProvider>
        </div>
      </div>
    </FBPage>
  )
}
